var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLexusArrow = function SvgLexusArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.03 7.47a.75.75 0 1 0-1.06 1.06l.72.72H1.5a.75.75 0 0 0 0 1.5h15.19l-.72.72a.75.75 0 1 0 1.06 1.06L19.56 10z"
  })));
};
export default SvgLexusArrow;